---@meta

---@class CommandArgOpts
---@field name string
---@field default any
---@field optional boolean
---@field vararg boolean

---@class CommandArg
---@field type string
---@field name string
---@field optional boolean
---@field default any
---@field vararg boolean

---@class Command
---@field tokenize fun(input: string): table
---@field parse fun(tokens: table, schema: table): table, string
---@field string fun(opts: CommandArgOpts): CommandArg
---@field number fun(opts: CommandArgOpts): CommandArg
---@field boolean fun(opts: CommandArgOpts): CommandArg
---@field exact fun(expected: any, inner: CommandArg): CommandArg
---@field enum fun(options: table): CommandArg
---@field flag fun(short: string, long: string, value_type: CommandArg, options: table): table
---@field dispatch fun(schema: table, input: string): boolean, string
---@field help fun(schema: table): string

command = {} ---@type Command
